// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__2sJu3","menu__contact":"Menu_menu__contact__2NMfz"};